<template>
    <div class="layout-wrapper">
        <div class="container-fluid">
            <div class="col-12">
                <div class="card shadow">
                    <div class="card-header bg-accent-grad glow-accent text-center">
                        <h4 class="text-white mb-0">فرم درخواست اعطای تسهیلات</h4>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <!--<div class="col-12 text-center">-->
                            <!--<div class="profile-image">-->
                            <!--<img :src="requestModel.userImage" class="img-fluid">-->
                            <!--</div>-->
                            <!--<input type="file" id="fileUpload" class="d-none"-->
                            <!--@change="onProfileImageChange($event)">-->
                            <!--<label for="fileUpload" class="btn btn-info btn-round mb-3 clickable">بارگذاری-->
                            <!--تصویر</label>-->
                            <!--</div>-->
                            <div class="col-12 mb-4">
                                <div class="input-group round">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">نوع وام</span>
                                    </div>
                                    <vs-select @onSearch="onDropDownFocused" @onSearchBlurred="onDropDownBlurred"
                                               :data="types" :mode="'create'"
                                               :header="{multiple: false, label: 'name'}"
                                               @onChange="onTypeChange">
                                    </vs-select>
                                </div>
                            </div>
                            <div v-if="!isAvilable && description !== null" class="text-center m-3">
                                <h6 class="text-info">{{description}}</h6>
                            </div>
                            <div v-if="isAvilable" class="col-12">
                                <div class="row">
                                    <div class="col-lg-6 mb-4">
                                        <div class="input-group round">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">مبلغ درخواستی</span>
                                            </div>
                                            <input class="form-control" type="number"
                                                   v-model="requestModel.requestAmount">
                                        </div>
                                        <small>حداکثر وام درخواستی {{avilableAmount.toLocaleString()}} ریال میباشد</small>
                                    </div>
                                    <div class="col-lg-6 mb-4">
                                        <div class="input-group round">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">تعداد ماه اقساط</span>
                                            </div>
                                            <input class="form-control" type="number"
                                                   v-model="requestModel.numberOfinstallments">
                                        </div>
                                        <small>حداکثر تعداد ماه اقساط {{numberOfinstallments}} ماه میباشد</small>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12 text-center my-4">
                                <div v-if="isAvilable">
                                    <button class="btn btn-primary btn-round" @click="submitUserForm">ثبت درخواست
                                    </button>
                                </div>
                                <div v-else>
                                    <button class="btn btn-primary btn-round" @click="returnToHome">بازگشت به
                                        پیشخوان
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import BaseService from "../../_framework/api/BaseService";
    import Moment from 'moment-jalali';
    import DatePicker from '../../_framework/vue-persian-datetime-picker/VuePersianDatetimePicker.vue';
    import VsSelect from "../../_framework/VsSelect";
    import Utils from "../../_framework/utils/Utils";
    import EventBus from "../../_framework/event-bus";

    export default {
        name: "newrequest",
        components: {VsSelect, DatePicker},
        data() {
            return {
                requestModel: {
                    id: 0,
                    // createdOn: "",
                    fiscalYear: 0,
                    row: 0,
                    // dateOfRegistration: "",
                    letterNumber: "",
                    // letterDate: "",
                    loanRemain: 0,
                    depositRemain: 0,
                    requestAmount: 0,
                    numberOfinstallments: 0,
                    accountTotalTitleDepositId: 0,
                    accountDetailedOneTitleLoanId: 0,
                    loanTypeId: 0,


                    status: "",
                    memberName: "",
                    memberId: 0,
                    accountTotalTitleDeposit: "",

                    accountDetailedOneTitleLoan: "",

                    loanType: "",


                },
                isLoading: false,

                types: [],
                isAvilable: false,
                avilableAmount: 0,
                numberOfinstallments: 0,
                description: "",

            }
        },
        mounted() {

            // this.getProvince();
            // this.requestModel.userImage = this.validateProfilePlaceholder(this.validateImageUrl(this.validateProfileImage(this.requestModel.userImage)));
            // this.requestModel.userImage = this.validateImageUrl(this.requestModel.userImage);
            this.GetLoanTypes();
        },
        methods: {
            GetLoanTypes() {
                new BaseService("Request", "/GetLoanTypes").getList().then(response => {
                    this.types = response.data.data;
                    for (let i of this.types) {
                        i.name = "وام " + i.loanName + " " + i.numberOfinstallments + " ماهه با کارمزد " + i.percentageOfFees + " درصد";
                    }
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },
            onTypeChange(val) {
                if (val !== null) {
                    this.requestModel.loanTypeId = val.id;
                    this.isAvilable = val.isAilable;
                    this.description = val.description;
                    this.avilableAmount = val.avilableAmount;
                    this.numberOfinstallments = val.numberOfinstallments;
                }
            },


            submitUserForm() {
                if (this.requestModel.loanTypeId === 0) {
                    Utils.handleErrorWithNotification("لطفا نوع وام درخواستی را مشخص کنید", this.$noty);
                } else {
                    this.isLoading = true;
                    new BaseService("Request", "/NewRequest").create(this.requestModel).then(response => {
                        this.isLoading = false;
                        // console.log(response.data)
                        this.$noty.success('درخواست شما با موفقیت ثبت شد', {timeout: 1000})
                        this.$router.push({name: "home"})
                    }).catch(error => {
                        Utils.handleErrorWithNotification(error.data, this.$noty);
                    });
                }
            },
            returnToHome() {
                this.$router.push({name: "home"})
            },
            validateProfilePlaceholder(img) {
                // let final = img.substr(img.lastIndexOf('/') + 1);
                // let file = final.split('.');
                // return "/img/" + file[0] + '.' + file[2];
            }
        }
    }
</script>

<style lang="scss" scoped>
    .profile-image {
        margin: 0 auto 1rem auto;
    }

    .profile-image img {
        max-width: 150px;
        border-radius: 1rem;
        box-shadow: 0 10px 25px -10px rgba(0, 0, 0, 0.25);
    }
</style>